/**
 * react-helmet-async ships as CommonJS; Vite's SSR module runner cannot
 * resolve its named exports directly ("Named export 'HelmetProvider' not
 * found"). Import the module namespace and unwrap the default-interop shape
 * so both the browser and SSR builds get working references.
 */
import * as helmetNs from "react-helmet-async";

type HelmetModule = typeof import("react-helmet-async");

const resolved = ((helmetNs as { default?: HelmetModule }).default ??
  helmetNs) as HelmetModule;

export const Helmet = resolved.Helmet;
export const HelmetProvider = resolved.HelmetProvider;
